
import React, { useEffect,useState } from 'react';
import { Layout, Breadcrumb,Row, Col, Button, Table, Tag, Drawer, Form, Select, Input, Space, message, Modal, Switch, DatePicker, Divider } from 'antd';
import { EditOutlined, SendOutlined, DeleteOutlined,PlusOutlined,ExclamationCircleOutlined } from '@ant-design/icons';
import './style.scss'
import { useNavigate } from "react-router-dom";
import Colors from '../../assets/themes/colors';
import GlobalSider from '../../components/GlobalSider';
import { addDataWithToken, appIdentifier, dateFormat, deleteDataWithToken, editDataWithToken, getDataWithToken, getLocal } from '../../globalFunctions/api';
import GlobalHeader from '../../components/GlobalHeader';
import moment from 'moment';
const {Content} = Layout;
const { Column, ColumnGroup } = Table;
const { Option } = Select;
const {confirm} = Modal

const pageTitle = 'ادارة التدريسيين';

const  MngInfos = ()=> {
    const navigate = useNavigate();
    const [addInfoForm] = Form.useForm()
    const [editInfoForm] = Form.useForm()

    const [addInfoVisible, setAddInfoVisible] = useState(false);
    const [editInfoVisible, setEditInfoVisible] = useState(false);
    
    const [addLoading, setAddLoading] = useState(false);
    const [selectedInfo, setSelectedInfo] = useState(null)
    const [infoFormInfo, setInfoFormInfo] = useState(null)
    const [infos, setInfos] = useState([]);
    const [totalCount, setTotalCount] = useState(null);
    const [certificates, setcertificates] = useState([])
    const [scintificTitles, setscintificTitles] = useState([])
    const localUserType = getLocal(appIdentifier)?.user?.user_type || null 

    const handleTableChange = (pagination, filters, sorter) => {
        const{current,pageSize} = pagination 
        getInfos(current,pageSize)
      };


      const onAddClose = () => {
        setAddInfoVisible(false);
        setSelectedInfo(null)
        addInfoForm.resetFields()
        
      };

      const onEditClose = () => {
        setEditInfoVisible(false);
        setSelectedInfo(null)
        editInfoForm.resetFields()
        
      };

   
   

      const getInfos = (current=1,pageSize=25)=>{
        setAddLoading(true)
        getDataWithToken(`infos?populate[depart][fields][0]=title&populate[university][fields][0]=title&populate[certificate][fields][0]=title&populate[college][fields][0]=title&populate[scintific_title][fields][0]=title&&populate[admin][fields][0]=username&pagination[pageSize]=${pageSize}&pagination[page]=${current}`,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setInfos(result?.data);
            setTotalCount(result?.meta?.total)
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      const getCertificates = (current=1,pageSize=25)=>{
        getDataWithToken(`certificates`,
        (err,result)=>{
         
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setcertificates(result?.data);
           }else{
            console.log(error)
             message?.error(error?.message)
           }
          }
        }) 
      }

      const getScintificTitles = ()=>{
        getDataWithToken(`scintific-titles`,
        (err,result)=>{
         
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setscintificTitles(result?.data);
           }else{
            console.log(error)
             message?.error(error?.message)
           }
          }
        }) 
      }

      const addInfo = (data)=>{
        setAddLoading(true)
        addDataWithToken(`infos`,data,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            message?.success('تم اضافة التدريسي بنجاح');
            getInfos();
            addInfoForm?.resetFields();
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      function showDeleteConfirm(A_field_name,id) {
        confirm({
            title: `  هل انت متأكد انك تريد حذف  ( ${A_field_name} )  `,
            icon: <ExclamationCircleOutlined style={{color:'red'}} />,
            content: 'ملاحظة : البيانات المحذوفة لا يمكن استعادتها لاحقا',
            okText: 'نعم',
            okType: 'danger',
            cancelText: 'الغاء',
            width:480,
            style:{textAlign:'right'},
            onOk() {
                setAddLoading(true);
                deleteDataWithToken(`infos/${id}`,(err, result)=>{

                    const {error} = result
                    if(err){
                        message?.error('خطأ في الشبكة')
                    }else{
                        if(!error){
                            message?.success('تم حذف التدريسي بنجاح');
                            getInfos();
                        }else{
                            console.log(error)
                            message?.error(error?.message)
                        }
                    
                    }
                })

            },
            onCancel() {
                console.log('Cancel');
            },
            });
        }   

        const prepareEdit = (data)=>{
            setSelectedInfo(data)
            const newData = {
                ...data,
                birthdate:moment(data?.birthdate),
                start_date:moment(data?.start_date),
                certificate:data?.certificate?.id,
                scintific_title:data?.scintific_title?.id
            }
            editInfoForm.setFieldsValue(newData)
            setEditInfoVisible(true)
        }

        const editInfo = (data)=>{
         
            setAddLoading(true);
            editDataWithToken(`infos/${selectedInfo?.id}`,data,(err, result)=>{
                const {error} = result
                if(err){
                    message?.error('خطأ في الشبكة')
                }else{
                    if(!error){
                        message?.success('تم تعديل التدريسي بنجاح');
                        getInfos();
                    }else{
                        console.log(error)
                        message?.error(error?.message)
                    }
                
                }
            })
          }


      useEffect(() => {
       getInfos();
       getCertificates();
       getScintificTitles();
      }, [])
      
    
    
    return(
        <Layout className='mainContainer'>

            <Drawer
                    title="اضافة تدريسي"
                    placement="left"
                    closable={false}
                    onClose={onAddClose}
                    visible={addInfoVisible}
                    width={window.innerWidth > 900 ? 700 :  350}
                >
                <Form 
                    form={addInfoForm} 
                    onFinish={addInfo}
                    onValuesChange={(changedValues,allValues)=>{
                        setInfoFormInfo(allValues);
                    }}
                    layout='inline'
                >

                    <Form.Item  
                        className='myFormItem' 
                        name="teacher_name" 
                        label="الاسم الرباعي"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة الاسم الرباعي',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="الاسم الرباعي"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="birthdate" 
                        label="تاريخ التولد"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة تاريخ التولد',
                            },
                            
                          ]}
                        >
                             <DatePicker size="large" style={{minWidth:250}} disabledDate={(current)=>current && current.valueOf() > Date.now()}  />
                    </Form.Item>

                    <Form.Item    
                    className='myFormItem'
                    name="certificate" 
                    rules={[{ required: true, message: 'يرجى اختيار الشهادة ' }]}
                    label="الشهادة"
                    >
                        <Select size="large"  placeholder="الشهادة" style={{minWidth:250}}>
                            {
                                certificates?.map(({id,title},index) => {
                                    return(<Option value={id} key={id} >{title}</Option>)
                                })
                            }
                        </Select>
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="specialization" 
                        label="الاختصاص العام"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة الاختصاص العام',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="الاختصاص العام"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="delicate_specialization" 
                        label="الاختصاص الدقيق"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة الاختصاص الدقيق',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="الاختصاص الدقيق"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item    
                    className='myFormItem'
                    name="scintific_title" 
                    rules={[{ required: true, message: 'يرجى اختيار اللقب العلمي ' }]}
                    label="اللقب العلمي"
                    >
                        <Select size="large"  placeholder="اللقب العلمي" style={{minWidth:250}}>
                            {
                                scintificTitles?.map(({id,title},index) => {
                                    return(<Option value={id} key={id} >{title}</Option>)
                                })
                            }
                        </Select>
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="email" 
                        label="البريد الالكتروني"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة البريد الالكتروني',
                            },
                            {
                                type:'email',
                                message: 'يرجى كتابة بريد الكتروني صحيح',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="البريد الالكتروني"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="phone" 
                        label=" رقم الهاتف"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة رقم الهاتف',
                            },
                            {
                                pattern:/^[0-9]*$/,
                                message: 'يقبل هذا الحقل ارقام فقط',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="رقم الهاتف"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="start_no" 
                        label="رقم كتاب المباشرة في القسم"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة رقم كتاب المباشرة في القسم',
                            },
                            
                          ]}
                        >
                             <Input size="large" placeholder="رقم كتاب المباشرة في القسم"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="start_date" 
                        label="تاريخ كتاب المباشرة في القسم"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة تاريخ كتاب المباشرة في القسم',
                            },
                            
                          ]}
                        >
                             <DatePicker size="large" style={{minWidth:250}} disabledDate={(current)=>current && current.valueOf() > Date.now()}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="comments" 
                        label="ملاحظات"
                        
                        >
                             <Input.TextArea size="large" placeholder="ملاحظات"  style={{minWidth:250}}  />
                    </Form.Item>
                    
                
                   

                    <Divider orientation="right" >اعداد الطلبة</Divider>
                    <Col md={24}  />

                    <Form.Item  
                        className='myFormItem' 
                        name="diplom_stu" 
                        label="عدد طلبة الدبلوم العالي"
                        >
                             <Input type={'number'} min={0} size="large" placeholder="عدد طلبة الدبلوم العالي"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="master_stu" 
                        label="عدد طلبة الماجستير"
                        >
                             <Input type={'number'} min={0} size="large" placeholder="عدد طلبة الماجستير"  style={{minWidth:250}}  />
                    </Form.Item>
                    
                    <Form.Item  
                        className='myFormItem' 
                        name="phd_stu" 
                        label="عدد طلبة الدكتوراه"
                        >
                             <Input type={'number'} min={0} size="large" placeholder="عدد طلبة الدكتوراه"  style={{minWidth:250}}  />
                    </Form.Item>

                    
                    <Col md={24} style={{marginBottom:20}}  />
                    
                    <Button  style={{backgroundColor:Colors.primary, borderWidth:0, marginRight:10}}  type="primary"  icon={<SendOutlined />} onClick={()=>{addInfoForm.submit()}} loading={false} >
                          ارسال الطلب
                    </Button>
                    
                </Form>

            </Drawer>


            <Drawer
                    title={`تعديل ${selectedInfo?.teacher_name}`}
                    placement="left"
                    closable={false}
                    onClose={onEditClose}
                    visible={editInfoVisible}
                    width={window.innerWidth > 900 ? 700 :  350}
                >
                <Form 
                    form={editInfoForm} 
                    onFinish={editInfo}
                    onValuesChange={(changedValues,allValues)=>{
                        setInfoFormInfo(allValues);
                    }}
                    layout='inline'
                >

<Form.Item  
                        className='myFormItem' 
                        name="teacher_name" 
                        label="الاسم الرباعي"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة الاسم الرباعي',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="الاسم الرباعي"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="birthdate" 
                        label="تاريخ التولد"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة تاريخ التولد',
                            },
                            
                          ]}
                        >
                             <DatePicker size="large" style={{minWidth:250}} disabledDate={(current)=>current && current.valueOf() > Date.now()}  />
                    </Form.Item>

                    <Form.Item    
                    className='myFormItem'
                    name="certificate" 
                    rules={[{ required: true, message: 'يرجى اختيار الشهادة ' }]}
                    label="الشهادة"
                    >
                        <Select size="large"  placeholder="الشهادة" style={{minWidth:250}}>
                            {
                                certificates?.map(({id,title},index) => {
                                    return(<Option value={id} key={id} >{title}</Option>)
                                })
                            }
                        </Select>
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="specialization" 
                        label="الاختصاص العام"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة الاختصاص العام',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="الاختصاص العام"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="delicate_specialization" 
                        label="الاختصاص الدقيق"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة الاختصاص الدقيق',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="الاختصاص الدقيق"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item    
                    className='myFormItem'
                    name="scintific_title" 
                    rules={[{ required: true, message: 'يرجى اختيار اللقب العلمي ' }]}
                    label="اللقب العلمي"
                    >
                        <Select size="large"  placeholder="اللقب العلمي" style={{minWidth:250}}>
                            {
                                scintificTitles?.map(({id,title},index) => {
                                    return(<Option value={id} key={id} >{title}</Option>)
                                })
                            }
                        </Select>
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="email" 
                        label="البريد الالكتروني"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة البريد الالكتروني',
                            },
                            {
                                type:'email',
                                message: 'يرجى كتابة بريد الكتروني صحيح',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="البريد الالكتروني"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="phone" 
                        label=" رقم الهاتف"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة رقم الهاتف',
                            },
                            {
                                pattern:/^[0-9]*$/,
                                message: 'يقبل هذا الحقل ارقام فقط',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="رقم الهاتف"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="start_no" 
                        label="رقم كتاب المباشرة في القسم"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة رقم كتاب المباشرة في القسم',
                            },
                            
                          ]}
                        >
                             <Input size="large" placeholder="رقم كتاب المباشرة في القسم"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="start_date" 
                        label="تاريخ كتاب المباشرة في القسم"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة تاريخ كتاب المباشرة في القسم',
                            },
                            
                          ]}
                        >
                             <DatePicker size="large" style={{minWidth:250}} disabledDate={(current)=>current && current.valueOf() > Date.now()}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="comments" 
                        label="ملاحظات"
                        
                        >
                             <Input.TextArea size="large" placeholder="ملاحظات"  style={{minWidth:250}}  />
                    </Form.Item>
                    
                
                   

                    <Divider orientation="right" >اعداد الطلبة</Divider>
                    <Col md={24}  />

                    <Form.Item  
                        className='myFormItem' 
                        name="diplom_stu" 
                        label="عدد طلبة الدبلوم العالي"
                        >
                             <Input type={'number'} min={0} size="large" placeholder="عدد طلبة الدبلوم العالي"  style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="master_stu" 
                        label="عدد طلبة الماجستير"
                        >
                             <Input type={'number'} min={0} size="large" placeholder="عدد طلبة الماجستير"  style={{minWidth:250}}  />
                    </Form.Item>
                    
                    <Form.Item  
                        className='myFormItem' 
                        name="phd_stu" 
                        label="عدد طلبة الدكتوراه"
                        >
                             <Input type={'number'} min={0} size="large" placeholder="عدد طلبة الدكتوراه"  style={{minWidth:250}}  />
                    </Form.Item>

                    
                    <Col md={24} style={{marginBottom:20}}  />
                    
                    
                    <Button  style={{backgroundColor:Colors.primary, borderWidth:0}}  type="primary"  icon={<SendOutlined />} onClick={()=>{editInfoForm.submit()}} loading={false} >
                          ارسال الطلب
                    </Button>
                    
                </Form>

            </Drawer>
        
            <GlobalHeader title={pageTitle}/>
            <Layout>
            
            <GlobalSider currentPage={'infos'} currentSub={'sub1'} />
            <Layout
                style={{
                padding: '0 24px 24px',
                }}
            >
                <Breadcrumb
                style={{
                    margin: '16px 0',
                }}
                >
                <Breadcrumb.Item onClick={()=>navigate('/mnghome')}  style={{cursor: 'pointer'}} >الرئيسية</Breadcrumb.Item>
                <Breadcrumb.Item>{pageTitle}</Breadcrumb.Item>
                
                
                </Breadcrumb>
                <Content
                className="site-layout-background"
                style={{
                    padding: 24,
                    margin: 0,
                    minHeight: 280,
                }}
                >
                <Row  style={{padding:10}} >

                <Col md={24} >
                    {
                        localUserType==='depart'&&
                        <Button onClick={()=> setAddInfoVisible(true) } style={{backgroundColor:Colors.primary, borderWidth:0}} type="primary" shape="round" icon={<PlusOutlined />} size={20}>
                            اضافة  تدريسي
                        </Button>
                    }
                   
                   </Col>

                    <Col md={24} style={{marginTop:24}}>

                    <Table 
                        dataSource={infos}
                        pagination={{ position: ['bottomCenter'],total:totalCount}}
                        onChange={handleTableChange}
                        loading={addLoading}
                        scroll={{ x: '100%'}}
                    >

                    

                        <Column title="اسم التدريسي"  width="200px" key="teacher_name" fixed="left" dataIndex="teacher_name" />

                        <Column title="الشهادة"  width="200px" key="certificate" 
                            render={(text, record) => (
                                <Space>
                                    {record?.certificate?.title}
                                </Space>
                                
                            )}
                        />

                        <Column title="الاختصاص"  width="200px" key="specialization" dataIndex="specialization" />

                        <Column title="الاختصاص الدقيق"  width="200px" key="delicate_specialization" 
                            render={(text, record) => (
                                <Space>
                                    {record?.delicate_specialization}
                                </Space>
                                
                            )}
                        />

                        <Column title="اللقب العلمي"  width="200px" key="scintific_title" 
                            render={(text, record) => (
                                <Space>
                                    {record?.scintific_title?.title}
                                </Space>
                                
                            )}
                        />

                        <Column title="الجامعة"  width="200px" key="university" 
                            render={(text, record) => (
                                <Space>
                                    {record?.university?.title}
                                </Space>
                                
                            )}
                        />

                        <Column title="الكلية"  width="200px" key="college" 
                            render={(text, record) => (
                                <Space>
                                    {record?.college?.title}
                                </Space>
                                
                            )}
                        />

                        <Column title="القسم"  width="200px" key="depart" 
                            render={(text, record) => (
                                <Space>
                                    {record?.depart?.title}
                                </Space>
                                
                            )}
                        />

                        <Column title="البريد الالكتروني"  width="200px" key="email"  dataIndex="email" />
                        <Column title="رقم الهاتف"  width="200px" key="phone"  dataIndex="phone" />
                        <Column title="تاريخ الميلاد"  width="200px" key="birthdate" dataIndex="birthdate" />
                        <Column title="عدد طلبة الدبلوم"  width="200px" key="diplom_stu" dataIndex="diplom_stu" />
                        <Column title="عدد طلبة الماجستير"  width="200px" key="master_stu" dataIndex="master_stu" />
                        <Column title="عدد طلبة الدكتوراه"  width="200px" key="phd_stu" dataIndex="phd_stu" />
                        <Column title="رقم كتاب المباشرة في القسم"  width="200px" key="start_no" dataIndex="start_no" />
                        <Column title="تاريخ كتاب المباشرة في القسم"  width="200px" key="start_date" dataIndex="start_date" />
                        <Column title="تاريخ اخر تعديل"  width="200px" key="updatedAt" 
                            render={(text, record) => (
                                <Space>
                                    { moment(record?.updatedAt).format(dateFormat) }
                                </Space>
                                
                            )}
                        />
                        <Column title="تم التعديل من قبل"  width="200px" key="updatedAt" 
                            render={(text, record) => (
                                <Space>
                                    { record?.admin?.username||''}
                                </Space>
                                
                            )}
                        />

                        
                        {
                            localUserType==='depart'&&
                            <Column title="العمليات"  width="200px" key="status" 
                                fixed='right'
                                render={(text, record) => (
                                    <Space>
                                    <Button onClick={()=> prepareEdit({id:record?.id,...record}) } style={{backgroundColor:Colors.primary, borderWidth:0}} type="primary" shape="round" icon={<EditOutlined />} size={20}>
                                        تعديل
                                    </Button>

                                    <Button onClick={()=> showDeleteConfirm(record?.teacher_name, record?.id) } style={{backgroundColor:Colors.red, borderWidth:0}} type="primary" shape="round" icon={<DeleteOutlined />} size={20}>
                                        حذف
                                    </Button>
                                    </Space>
                                    
                                )}
                            />

                        }
                         
                
                    </Table>

                    </Col>
                   
                </Row>
                </Content>
            </Layout>
            </Layout>
        </Layout>
    )
}

export default MngInfos




